import { RedirectToSamlTaskType } from '@common/enums/redirectToSamlTaskType';
import { getLanguage } from '@common/translate/translate';
import { RespiAllerEditButtonRow } from '../RespiAllerEditButtonRow';
import { RespiAllerGradingContent } from './RespiAllerGradingContent';

export function RespiAllerGradingEdit() {
    return (
        <>
            <RespiAllerGradingContent />
            <RespiAllerEditButtonRow
                label={getLanguage().allergology.gradeExamination}
                taskType={RedirectToSamlTaskType.EvidencioGrading}
            />
        </>
    );
}
